
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { store } from '@/store';

@Component
export default class InfoUtente extends Vue {

    get user() {
      return store.state.currentUsr;
  }

  get userIsAdmin() {
      return this.user.roles.find((x: string) => x.toLowerCase() == 'admin') != undefined;
  }
}

